import './plazaStyle.css';
export default function Plaza(){
    return(
        <div class="plaza">Welcome to the Plaza!</div>
    );
}